import React, {useEffect, useMemo, useState} from "react";
import PaginatedFlatTable from "../pagination/PaginatedFlatTable";
import useTranslation from "../../i18n/useTranslation";

export default function MarketplaceTopSearchesTable({items = [], title, subtitle, emptyText, pageSize = 8}) {
    const {t} = useTranslation();
    const [page, setPage] = useState(1);
    const pages = Math.max(1, Math.ceil(items.length / pageSize));

    useEffect(() => {
        setPage((currentPage) => Math.min(currentPage, pages));
    }, [pages]);

    const visibleItems = useMemo(() => items.slice((page - 1) * pageSize, page * pageSize), [items, page, pageSize]);

    return <PaginatedFlatTable
        title={title}
        subtitle={subtitle}
        page={page}
        pages={pages}
        items={visibleItems}
        totalCount={items.length}
        onPageChange={setPage}
        headers={[t("marketplaceModerationPage.searchRank", {}, "#"), t("marketplaceModerationPage.searchTerm", {}, "Search"), t("marketplaceModerationPage.searches", {}, "Searches")]}
        renderRow={(search, index) => <tr key={search.searchTerm}>
            <td style={{width: 58, color: "#667085", fontWeight: 900}}>{(page - 1) * pageSize + index + 1}</td>
            <td style={{color: "#263241", fontWeight: 800}}>{search.searchTerm}</td>
            <td className="text-right" style={{color: "#263241", fontWeight: 900}}>{search.count}</td>
        </tr>}
        emptyText={emptyText}
    />;
}
